/**
 * crmBuilder — sub-container do slice CRM (Lead + Pipeline + Opportunity).
 *
 * Extraído de `container.ts` na Sprint F.5-polish-extras-3 pra reduzir o
 * monólito de DI. Mantém o padrão estabelecido pelo `commerceBuilder.ts`.
 *
 * @since F.5-polish-extras-3
 */
import type { $Fetch } from 'ofetch';

import { HttpLeadGateway } from '@/infrastructure/http/HttpLeadGateway';
import { HttpPipelineGateway } from '@/infrastructure/http/HttpPipelineGateway';
import { HttpOpportunityGateway } from '@/infrastructure/http/HttpOpportunityGateway';

import {
  ListLeads, GetLead, MoverLeadStage, MarcarLeadPerdido,
} from '@/application/usecase/LeadUseCaseImpl';
import {
  ListPipelines, ListPipelineStages, CreatePipeline, UpdatePipeline, DeactivatePipeline,
} from '@/application/usecase/PipelineUseCaseImpl';
import {
  ListOpportunities, GetOpportunity, CriarOpportunity, TransicionarOpportunity, ConverterOpportunity,
} from '@/application/usecase/OpportunityUseCaseImpl';

export function buildCrmSlice(httpClient: $Fetch) {
  const leadGateway = new HttpLeadGateway(httpClient);
  const pipelineGateway = new HttpPipelineGateway(httpClient);
  const opportunityGateway = new HttpOpportunityGateway(httpClient);

  const useCases = {
    listLeads: new ListLeads(leadGateway),
    getLead: new GetLead(leadGateway),
    moverLeadStage: new MoverLeadStage(leadGateway),
    marcarLeadPerdido: new MarcarLeadPerdido(leadGateway),
    listPipelines: new ListPipelines(pipelineGateway),
    listPipelineStages: new ListPipelineStages(pipelineGateway),
    createPipeline: new CreatePipeline(pipelineGateway),
    updatePipeline: new UpdatePipeline(pipelineGateway),
    deactivatePipeline: new DeactivatePipeline(pipelineGateway),
    listOpportunities: new ListOpportunities(opportunityGateway),
    getOpportunity: new GetOpportunity(opportunityGateway),
    criarOpportunity: new CriarOpportunity(opportunityGateway),
    transicionarOpportunity: new TransicionarOpportunity(opportunityGateway),
    converterOpportunity: new ConverterOpportunity(opportunityGateway),
  };

  return { useCases };
}
